import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducer import
import customizationReducer from './customization';
import snackbarReducer from './snackbar';
import cartReducer from './cart';
import authReducer from './auth';
import toolsReducer from './tools';
import techniquesReducer from './techniques';
import manufacturersReducer from './manufacturers';
import productsReducer from './products';
import eventsReducer from './events';
import sponsorsReducer from './sponsors';
import usersReducer from './users';
import aboutReducer from './about';
import toolLevelsReducer from './toolLevels';
import analyticsReducer from './analytics'; // Add this line

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  customization: customizationReducer,
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: 'cart',
      storage,
      keyPrefix: 'berry-',
    },
    cartReducer
  ),
  auth: authReducer,
  tools: toolsReducer,
  techniques: techniquesReducer,
  manufacturers: manufacturersReducer,
  products: productsReducer,
  events: eventsReducer,
  sponsors: sponsorsReducer,
  users: usersReducer,
  about: aboutReducer,
  toolLevels: toolLevelsReducer,
  analytics: analyticsReducer, // Add this line
});

export default reducer;